export default __webpack_public_path__ + "static/media/home-logo-image.68bcf570.png";